/* eslint-disable import/prefer-default-export */

export const isValid = val => ((typeof val !== 'undefined') && val !== null);
